// extracted by css-extract-rspack-plugin
export default {"customerStory":"FlexSuiteRiverBreakout-module__customerStory__L9LR9","customerStoryLogo":"FlexSuiteRiverBreakout-module__customerStoryLogo__VUYPM"};